<script>
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import Layout from "../../layouts/main";
// for highcharts
import Vue from "vue";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from 'highcharts/modules/exporting';
import { ModelListSelect } from "vue-search-select";
// import DatePicker from "vue2-datepicker";
// import moment from "moment";

Vue.use(HighchartsVue);
exportingInit(Highcharts);

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    ModelListSelect,
    Layout
    // DatePicker
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      chartOptions: {
         exporting: {
              buttons: {
                  contextButton: {
                      menuItems: ['viewFullscreen', 'downloadPNG', 'downloadJPEG', 'downloadPDF']
                  }
              }
          },
         chart: {
            type: 'column',
          },
          title: {
            text: 'Poscream Pro Monthly Sales and Purchases'
          },
          subtitle: {
            text: 'Source: poscream.com'
          },
          xAxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
              'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            accessibility: {
              description: 'Months of the year'
            }
          },
          yAxis: {
            title: {
              text: 'Amount'
            },
            labels: {
              formatter: function () {
                return this.value;
              }
            }
          },
          tooltip: {
            crosshairs: true,
            shared: true
          },
          plotOptions: {
            spline: {
              marker: {
                radius: 4,
                lineColor: '#666666',
                lineWidth: 1
              }
            }
          },
          
          series: [{
            name: 'Sales',
            color: "#fab131",
            marker: {
              symbol: 'square'
            },
            data: [0,0,0,0,0,0,0,0,0,0,0,0]

          }, {
            name: 'Purchases',
            color: "#C6FA07",
            marker: {
              symbol: 'diamond'
            },
            data:[0,0,0,0,0,0,0,0,0,0,0,0]
          }]          
      },
      timeFilters: [
        { title: "Today", value: "today" },
        { title: "Yesterday", value: "yesterday" },
        { title: "Last 7 days", value: "last7" },
        { title: "Last 14 days", value: "last14" },
        { title: "Last 28 days", value: "last28" },
        { title: "This month", value: "month" },
        { title: "This quarter", value: "quarter" },
        { title: "Customise", value: "custom" },
      ],
      filterData: {
        time: "today",
        from: "",
        to: "",
        branch_id:0
      },
      dashboardLabel: "Today's",
   
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("analysis", ["Summary", "filterStatus"]),
    ...mapGetters("auth", ["name","MyUserPerm", "Branches","branchid"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    CombinedDashboard() {
      return this.GeneralSettings.combined_dashboard == 1 && this.MyUserPerm.view_combineddashboard == 1; 
    }
  },
  // },
  methods: {
    ...mapActions({
      FetchSummary: "analysis/fetchSummary",
      FetchBraches: "auth/fetchBranches",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
    }),
    assignGraph(){
      this.chartOptions.series[0].data= this.Summary  ? this.Summary.msales : [0,0,0,0,0,0,0,0,0,0,0,0];
      this.chartOptions.series[1].data= this.Summary  ? this.Summary.mpurchases : [0,0,0,0,0,0,0,0,0,0,0,0];
    },
    FetchSummaryData(){
      this.FetchSummary(this.filterData);
    },
    setLabel() {
      if (this.filterData.time == "today") {
        this.dashboardLabel = "Today's";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "yesterday") {
        this.dashboardLabel = "Yesterday's";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "last7") {
        this.dashboardLabel = "Last 7 days";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "last14") {
        this.dashboardLabel = "Last 14 days";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "last28") {
        this.dashboardLabel = "Last 28 days";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "month") {
        this.dashboardLabel = "This month's";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "quarter") {
        this.dashboardLabel = "This quarter's";
        this.filterData.from = "";
        this.filterData.to = "";
      }
      if (this.filterData.time == "custom") {
        this.filterData.from = "";
        this.filterData.to = "";
      }
    },

    fuelslogin(){
      window.open(
        `https://poscream.com/pms/main/login.php?id=${(this.Summary.global_id)}`
      );
    },
     thousandSeperator(m) {
      if (m === "" || m === undefined || m === null) {
        return m;
      }
      const str = m.toString();
      const integerPart = str.split(".")[0];
      return integerPart
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatNumber(value) {
      return Number(value || 0).toLocaleString();
    },
  },
  watch:{
    Summary(newValue){
      if(newValue){
        this.assignGraph();
      }
    }
  },
  updated(){
    this.assignGraph();    
  },

  created() {
    this.FetchSummary(this.filterData);
    this.assignGraph();
    this.FetchGeneralSettings();
    this.FetchBraches();
  },
};
</script>

<template>
<div>
  <Layout v-if="!CombinedDashboard">
    <div v-if="!CombinedDashboard">
      <div class="row" v-if="MyUserPerm.view_user_summary == 1 && MyUserPerm.view_dashboard== 1 && MyUserPerm.view_general_summary == 0">
      <div class="row py-3 text-center">
        <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{Summary.businessname}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && Summary.branchname"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{Summary.branchname}}</h4>
      </div>
      <div class="row" v-if="branchid == 0">
        <div class="col-md-8"></div>
        <div class="col-md-4 mb-3">
          <label>FILTER BY BRANCHES</label>
          
          <model-list-select
            :list="Branches ? Branches : []"
            v-model="filterData.branch_id"
            option-value="id"
            option-text="name"
            placeholder="Select Branch"
            @input="FilterProducts()"
          >
          </model-list-select>
        </div>
      </div> 
      <div class="row">    
        <div class="col-md-3">
          <label>FILTER BY TIME</label>
          <model-list-select
            :list="this.timeFilters ? this.timeFilters : []"
            v-model="filterData.time"
            option-value="value"
            size="sm"
            @input="
              setLabel();
              FetchSummaryData();
            "
            option-text="title"
            placeholder="Select Performance"
          >
          </model-list-select>
        </div>
        <div class="col-md-3" v-show="filterData.time == 'custom'">
          <label>FROM</label>
          <input
              type="date"
              class="form-control"
              v-model="filterData.from"
              v-limit-future-date
            />
        </div>
        <div class="col-md-3" v-show="filterData.time == 'custom'">
          <label>To</label>
          <input
              type="date"
              class="form-control"
              v-model="filterData.to"
              v-limit-future-date
            />
        </div>
          <div class="col-md-3 mt-4" align="right">
          <button class="btn btn-warning" type="button" @click="FetchSummaryData()">
            <span class="fa fa-filter"></span> Filter
            <b-spinner
              v-show="filterStatus"
              variant="light"
              small
              role="status"
            ></b-spinner>
          </button>
        </div>
      </div> 
      <div class="row">
        <h4>{{ dashboardLabel || filterData.from == "" ? dashboardLabel:(filterData.from.toDateString())+' - '+(filterData.to.toDateString()) }} Summary</h4>
        <div class="col-md-6">
          <div class="col-xl-12">
            <div class="row" v-if="GeneralSettings.cash_at_hand == 1">
              <div class="col-lg-12 SummaryDiv">
                <div class="card mini-stats-wid smrcard2">
                  <div class="card-body">
                    <!-- <div class="d-flex flex-wrap"> -->
                      <!-- <div class="me-3"> -->                        
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Sales</h4>

                            </div>                            
                            <div class="col-md-7">
                            <router-link :to="'/advanced_reports/sales_report'">
                                <h4 class="mb-0" align="right">{{ Summary?.currency_code || '' }} :
                                {{ formatNumber(Summary?.sales) }}
                                </h4>
                            </router-link>
                            </div>
                          </div>
                        
                        
                      <!-- </div> -->

                    <!-- </div> -->
                  </div>
                </div>
                
              </div>

              <div class="col-lg-12">
                <div class="card mini-stats-wid smrcard2">
                  <div class="card-body">
                    <!-- <div class="d-flex flex-wrap"> -->
                      <!-- <div class="me-3"> -->
                        <div class="row">
                          <div class="col-md-5">
                            <h4 class="text-muted mb-0">
                           <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                             Credit Sales</h4>

                          </div>
                          <div class="col-md-7">
                            <router-link :to="'/sales/debtors'">
                              <h4 class="mb-0" align="right">
                                {{Summary?.currency_code || ''}}: {{formatNumber(Summary?.debts)}}
                              </h4>
                            </router-link>
                          </div>
                        </div>

                        
                      <!-- </div> -->

                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="card mini-stats-wid smrcard2">
                  <div class="card-body">
                    <!-- <div class="d-flex flex-wrap"> -->
                      <!-- <div class="me-3"> -->
                        <div class="row">
                          <div class="col-md-5">
                            <h4 class="text-muted mb-0">
                           <i class="bx bxs-book-bookmark bg-light rounded-circle text-primary font-size-20"></i> 
                             Credits Paid</h4>

                          </div>
                          <div class="col-md-7">
                            <router-link :to="'/advanced_reports/credit_payments'">
                              <h4 class="mb-0" align="right">{{Summary?.currency_code || ''}}: {{formatNumber(Summary?.credit)}}</h4>
                            </router-link>
                          </div>
                        </div>

                        
                      <!-- </div> -->

                    <!-- </div> -->
                  </div>
                </div>
              </div>

            </div>
            <div class="row" v-else>
              <div class="col-lg-12 SummaryDiv">
                <div class="card mini-stats-wid smrcard">
                  <div class="card-body">
                    <!-- <div class="d-flex flex-wrap"> -->
                      <!-- <div class="me-3"> -->                        
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Sales</h4>

                            </div>                            
                            <div class="col-md-7">
                            <router-link :to="'/advanced_reports/sales_report'">
                              <h4 class="mb-0" align="right">{{Summary?.currency_code || ''}} : {{formatNumber(Summary?.sales)}}</h4>
                            </router-link>
                            </div>
                          </div>
                        
                        
                      <!-- </div> -->

                    <!-- </div> -->
                  </div>
                </div>
                
              </div>

              <div class="col-lg-12">
                <div class="card mini-stats-wid smrcard">
                  <div class="card-body">
                    <!-- <div class="d-flex flex-wrap"> -->
                      <!-- <div class="me-3"> -->
                        <div class="row">
                          <div class="col-md-5">
                            <h4 class="text-muted mb-0">
                           <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                             Credit Sales</h4>

                          </div>
                          <div class="col-md-7">
                            <router-link :to="'/sales/debtors'">
                              <h4 class="mb-0" align="right">{{Summary?.currency_code || ''}}: {{formatNumber(Summary?.debts)}}</h4>
                            </router-link>
                          </div>
                        </div>

                        
                      <!-- </div> -->

                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- end row -->

          
          </div>
        <!-- end col -->
          
        
        </div>
        <div class="col-md-6">
          <div class="col-xl-12">
            <div class="row" v-if="GeneralSettings.cash_at_hand == 1">
              <div class="col-lg-12">
                <div class="card mini-stats-wid smrcard2">
                  <div class="card-body">
                    <!-- <div class="d-flex flex-wrap"> -->
                      <!-- <div class="me-3"> -->
                        <div class="row">
                          <div class="col-md-5">
                            <h4 class="text-muted mb-0">
                           <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                             Expenses</h4>

                          </div>
                          <div class="col-md-7">
                            <router-link :to="'/advanced_reports/expenses_report'">
                              <h4 class="mb-0" align="right">{{Summary?.currency_code || ''}}: {{formatNumber(Summary?.expenses)}}</h4>
                            </router-link>
                          </div>
                        </div>

                        
                      <!-- </div> -->

                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="card mini-stats-wid smrcard2">
                  <div class="card-body">
                    <!-- <div class="d-flex flex-wrap"> -->
                      <!-- <div class="me-3"> -->
                        <div class="row">
                          <div class="col-md-5">
                            <h4 class="text-muted mb-0">
                           <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                             Net Income</h4>

                          </div>
                          <div class="col-md-7">
                            <router-link :to="'/payment/options'">
                              <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.cash ? (Summary.cash).toLocaleString() : 0}}</h4>
                            </router-link>
                          </div>
                        </div>

                        
                      <!-- </div> -->

                    <!-- </div> -->
                  </div>
                </div>
              </div>

            </div>
            <div class="row" v-else>
              <div class="col-lg-12">
                <div class="card mini-stats-wid smrcard">
                  <div class="card-body">
                    <!-- <div class="d-flex flex-wrap"> -->
                      <!-- <div class="me-3"> -->
                        <div class="row">
                          <div class="col-md-5">
                            <h4 class="text-muted mb-0">
                           <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                             Credits Paid</h4>

                          </div>
                          <div class="col-md-7">
                            <router-link :to="'/advanced_reports/credit_payments'">
                              <h4 class="mb-0" align="right">{{Summary?.currency_code || ''}}: {{formatNumber(Summary?.cash)}}</h4>
                            </router-link>
                          </div>
                        </div>

                        
                      <!-- </div> -->

                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="card mini-stats-wid smrcard">
                  <div class="card-body">
                    <!-- <div class="d-flex flex-wrap"> -->
                      <!-- <div class="me-3"> -->
                        <div class="row">
                          <div class="col-md-5">
                            <h4 class="text-muted mb-0">
                           <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                             Expenses</h4>

                          </div>
                          <div class="col-md-7">
                            <router-link :to="'/advanced_reports/expenses_report'">
                              <h4 class="mb-0" align="right">{{Summary?.currency_code || ''}}: {{formatNumber(Summary?.credit)}}</h4>
                            </router-link>
                          </div>
                        </div>

                        
                      <!-- </div> -->

                    <!-- </div> -->
                  </div>
                </div>
              </div>

            </div>
            <!-- end row -->

          
          </div>
        <!-- end col -->
          
        
        </div>
      </div>      
      <!-- end col -->
      </div>
      <div class="row" v-if="MyUserPerm.view_general_summary == 1 && MyUserPerm.view_dashboard== 1 && MyUserPerm.view_user_summary == 0">
        <div class="row py-3 text-center">
          <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{Summary.businessname}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && Summary.branchname"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{Summary.branchname}}</h4>
        </div>
        <div class="row">
            <h4 class="text-center">General Summary</h4>
            <div class="col-lg-12">
              <div class="row" v-if="GeneralSettings.show_businessvalue == 1">
                <div class="col-md-6">
                  <div class="col-lg-12">
                    <div class="card mini-stats-wid smrcard2">
                      <div class="card-body">
                        <!-- <div class="d-flex flex-wrap"> -->
                          <!-- <div class="me-3"> -->
                            <div class="row">
                              <div class="col-md-5">
                                <h4 class="text-muted mb-0">
                              <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                                Stock Value</h4>
                              </div>
                              <div class="col-md-7">
                                <router-link :to="'/stock/stockvalue'">
                                  <h4 v-if="GeneralSettings.stockvalue_calculation == 0" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.BuyingstockValue ? (Summary.BuyingstockValue).toLocaleString() : 0}}</h4>
                                  <h4 v-if="GeneralSettings.stockvalue_calculation == 1" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.SellingstockValue ? (Summary.SellingstockValue).toLocaleString() : 0}}</h4>
                                </router-link>
                              </div>
                            </div>

                            
                          <!-- </div> -->

                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="card mini-stats-wid smrcard2">
                      <div class="card-body">
                        <!-- <div class="d-flex flex-wrap"> -->
                          <!-- <div class="me-3"> -->
                            <div class="row">
                              <div class="col-md-5">
                                <h4 class="text-muted mb-0">
                              <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                                Business Value</h4>
                              </div>
                              <div class="col-md-7">
                                <router-link :to="'/stock/stockvalue'">
                                  <h4 v-if="GeneralSettings.stockvalue_calculation == 0" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.Buying_businessvalue ? (Summary.Buying_businessvalue).toLocaleString() : 0}}</h4>
                                  <h4 v-if="GeneralSettings.stockvalue_calculation == 1" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.Selling_businessvalue ? (Summary.Selling_businessvalue).toLocaleString() : 0}}</h4>
                                </router-link>
                              </div>
                            </div>

                            
                          <!-- </div> -->

                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="card mini-stats-wid smrcard2">
                      <div class="card-body">
                        <!-- <div class="d-flex flex-wrap"> -->
                          <!-- <div class="me-3"> -->
                            <div class="row">
                              <div class="col-md-5">
                                <h4 class="text-muted mb-0">
                              <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                                Creditors</h4>

                              </div>
                              <div class="col-md-7">
                                <router-link :to="'/purchases/creditors'">
                                  <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.creditors ? (Summary.creditors).toLocaleString() : 0}}</h4>
                                </router-link>
                              </div>
                            </div>

                            
                          <!-- </div> -->

                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="col-lg-12">
                    <div class="card mini-stats-wid smrcard2">
                      <div class="card-body">
                        <!-- <div class="d-flex flex-wrap"> -->
                          <!-- <div class="me-3"> -->
                            <div class="row">
                              <div class="col-md-5">
                                <h4 class="text-muted mb-0">
                              <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                                In stock</h4>

                              </div>
                              <div class="col-md-7">
                                <router-link :to="'/stock/in_stock'">
                                  <h4 class="mb-0" align="right">{{Summary.instock ? (Summary.instock).toLocaleString() : 0}} Products</h4>
                                </router-link>
                              </div>
                            </div>

                            
                          <!-- </div> -->

                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="card mini-stats-wid smrcard2">
                      <div class="card-body">
                        <!-- <div class="d-flex flex-wrap"> -->
                          <!-- <div class="me-3"> -->
                            <div class="row">
                              <div class="col-md-5">
                                <h4 class="text-muted mb-0">
                              <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                                Out Of Stock</h4>

                              </div>
                              <div class="col-md-7">
                                <router-link :to="'/stock/outof_stock'">
                                  <h4 class="mb-0" align="right">{{Summary.outstock ? (Summary.outstock).toLocaleString() : 0}} Products</h4>
                                </router-link>
                              </div>
                            </div>

                            
                          <!-- </div> -->

                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-md-6">
                  <div class="col-lg-12">
                    <div class="card mini-stats-wid smrcard">
                      <div class="card-body">
                        <!-- <div class="d-flex flex-wrap"> -->
                          <!-- <div class="me-3"> -->
                            <div class="row">
                              <div class="col-md-5">
                                <h4 class="text-muted mb-0">
                              <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                                Stock Value</h4>
                              </div>
                              <div class="col-md-7">
                                <router-link :to="'/stock/stockvalue'">
                                  <h4 v-if="GeneralSettings.stockvalue_calculation == 0" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.BuyingstockValue ? (Summary.BuyingstockValue).toLocaleString() : 0}}</h4>
                                  <h4 v-if="GeneralSettings.stockvalue_calculation == 1" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.SellingstockValue ? (Summary.SellingstockValue).toLocaleString() : 0}}</h4>
                                </router-link>
                              </div>
                            </div>

                            
                          <!-- </div> -->

                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="card mini-stats-wid smrcard">
                      <div class="card-body">
                        <!-- <div class="d-flex flex-wrap"> -->
                          <!-- <div class="me-3"> -->
                            <div class="row">
                              <div class="col-md-5">
                                <h4 class="text-muted mb-0">
                              <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                                Creditors</h4>

                              </div>
                              <div class="col-md-7">
                                <router-link :to="'/purchases/creditors'">
                                  <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.creditors ? (Summary.creditors).toLocaleString() : 0}}</h4>
                                </router-link>
                              </div>
                            </div>

                            
                          <!-- </div> -->

                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="col-lg-12">
                    <div class="card mini-stats-wid smrcard">
                      <div class="card-body">
                        <!-- <div class="d-flex flex-wrap"> -->
                          <!-- <div class="me-3"> -->
                            <div class="row">
                              <div class="col-md-5">
                                <h4 class="text-muted mb-0">
                              <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                                In stock</h4>

                              </div>
                              <div class="col-md-7">
                                <router-link :to="'/stock/in_stock'">
                                  <h4 class="mb-0" align="right">{{Summary.instock ? (Summary.instock).toLocaleString() : 0}} Products</h4>
                                </router-link>
                              </div>
                            </div>

                            
                          <!-- </div> -->

                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="card mini-stats-wid smrcard">
                      <div class="card-body">
                        <!-- <div class="d-flex flex-wrap"> -->
                          <!-- <div class="me-3"> -->
                            <div class="row">
                              <div class="col-md-5">
                                <h4 class="text-muted mb-0">
                              <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                                Out Of Stock</h4>

                              </div>
                              <div class="col-md-7">
                                <router-link :to="'/stock/outof_stock'">
                                  <h4 class="mb-0" align="right">{{Summary.outstock ? (Summary.outstock).toLocaleString() : 0}} Products</h4>
                                </router-link>
                              </div>
                            </div>

                            
                          <!-- </div> -->

                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end row -->          
          </div>
        </div>
        
        <!-- end col -->
      </div>
      <div v-else>
        <!-- <PageHeader :title="title" :items="items" /> -->
      <div class="row" v-if="MyUserPerm.view_dashboard == 1 && MyUserPerm.view_general_summary == 1 && MyUserPerm.view_user_summary == 1">
        <div class="row py-3 text-center">
          <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{Summary.businessname}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && Summary.branchname"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{Summary.branchname}}</h4>
        </div>
        <div class="row">    
          <div class="col-md-3">
            <label>FILTER BY TIME</label>
            <model-list-select
              :list="this.timeFilters ? this.timeFilters : []"
              v-model="filterData.time"
              option-value="value"
              size="sm"
              @input="
                setLabel();
                FetchSummaryData();
              "
              option-text="title"
              placeholder="Select Performance"
            >
            </model-list-select>
          </div>
          <div class="col-md-3" v-show="filterData.time == 'custom'">
            <label>FROM</label>
            <input
                type="date"
                class="form-control"
                v-model="filterData.from"
              />
          </div>
          <div class="col-md-3" v-show="filterData.time == 'custom'">
            <label>To</label>
            <input
                type="date"
                class="form-control"
                v-model="filterData.to"
              />
          </div>                          
            <div v-if="branchid == 0" class="col-md-3 mb-3">
              <label>FILTER BY BRANCHES</label>
              
              <model-list-select
                :list="Branches ? Branches : []"
                v-model="filterData.branch_id"
                option-value="id"
                option-text="name"
                placeholder="Select Branch"
                @input="FetchSummaryData()"
              >
              </model-list-select>
            </div>
            <div class="col-md-3 mt-4" align="right">
            <button class="btn btn-warning" type="button" @click="FetchSummaryData()">
              <span class="fa fa-filter"></span> Filter
              <b-spinner
                v-show="filterStatus"
                variant="light"
                small
                role="status"
              ></b-spinner>
            </button>
          </div>
          </div> 
        <div class="row">
          <div class="col-md-6">
            <h4>{{ dashboardLabel || filterData.from == "" ? dashboardLabel:(filterData.from.toDateString())+' - '+(filterData.to.toDateString()) }} Summary</h4>
            <div class="col-xl-12">
              <div class="row" v-if="GeneralSettings.cash_at_hand == 1">
                <div class="col-lg-12 SummaryDiv">
                  <div class="card mini-stats-wid smrcard2">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->                        
                            <div class="row">
                              <div class="col-md-5">
                                <h4 class="text-muted mb-0">
                              <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                                Sales</h4>

                              </div>                            
                              <div class="col-md-7">
                              <router-link :to="'/advanced_reports/sales_report'">
                                <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{Summary.sales ? (Summary.sales).toLocaleString() : 0}}</h4>
                              </router-link>
                              </div>
                            </div>
                          
                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                  
                </div>

                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard2">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Credit Sales</h4>

                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/sales/debtors'">
                              <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.debts ? (Summary.debts ).toLocaleString() :0}}</h4>
                              </router-link>
                            </div>
                          </div>                        
                        <!-- </div> -->
                      <!-- </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard2">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark bg-light rounded-circle text-primary font-size-20"></i> 
                              Credits Paid</h4>

                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/advanced_reports/credit_payments'">
                                <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.credit ? (Summary.credit).toLocaleString() : 0}}</h4>
                              </router-link>
                            </div>
                          </div>                        
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard2">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Expenses</h4>

                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/advanced_reports/expenses_report'">
                                <h4 class="mb-0" align="right">{{Summary?.currency_code || ''}}: {{formatNumber(Summary?.expenses)}}</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard2">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Net Income</h4>
                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/payment/options'">
                                <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.cash ? (Summary.cash).toLocaleString() : 0}}</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>

              </div>
              <div class="row" v-else>
                <div class="col-lg-12 SummaryDiv">
                  <div class="card mini-stats-wid smrcard">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->                        
                            <div class="row">
                              <div class="col-md-5">
                                <h4 class="text-muted mb-0">
                              <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                                Sales</h4>

                              </div>                            
                              <div class="col-md-7">
                              <router-link :to="'/advanced_reports/sales_report'">
                                <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{Summary.sales ? (Summary.sales).toLocaleString() : 0}}</h4>
                              </router-link>
                              </div>
                            </div>
                          
                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                  
                </div>

                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Credit Sales</h4>

                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/sales/debtors'">
                                <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.debts ? (Summary.debts ).toLocaleString() :0}}</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Credits Paid</h4>
                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/advanced_reports/credit_payments'">
                                <h4 class="mb-0" align="right">{{Summary?.currency_code || ''}}: {{formatNumber(Summary?.credit)}}</h4>
                              </router-link>
                            </div>
                          </div>                        
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Expenses</h4>

                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/advanced_reports/expenses_report'">
                                <h4 class="mb-0" align="right">{{Summary?.currency_code || ''}}: {{formatNumber(Summary?.expenses)}}</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>

              </div>
              <!-- end row -->

            
            </div>
          <!-- end col -->
            
          
          </div>
          <div class="col-md-6">
            <h4>General Summary</h4>
            <div class="col-lg-12">
              <div class="row" v-if="GeneralSettings.show_businessvalue == 1">
                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard2">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Stock Value</h4>
                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/stock/stockvalue'">
                                <h4 v-if="GeneralSettings.stockvalue_calculation == 0" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.BuyingstockValue ? (Summary.BuyingstockValue).toLocaleString() : 0}}</h4>
                                <h4 v-if="GeneralSettings.stockvalue_calculation == 1" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.SellingstockValue ? (Summary.SellingstockValue).toLocaleString() : 0}}</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard2">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Business Value</h4>
                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/stock/stockvalue'">
                                <h4 v-if="GeneralSettings.stockvalue_calculation == 0" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.Buying_businessvalue ? (Summary.Buying_businessvalue).toLocaleString() : 0}}</h4>
                                <h4 v-if="GeneralSettings.stockvalue_calculation == 1" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.Selling_businessvalue ? (Summary.Selling_businessvalue).toLocaleString() : 0}}</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard2">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Creditors</h4>

                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/purchases/creditors'">
                                <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.creditors ? (Summary.creditors).toLocaleString() : 0}}</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard2">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              In stock</h4>

                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/stock/in_stock'">
                                <h4 class="mb-0" align="right">{{Summary.instock ? (Summary.instock).toLocaleString() : 0}} Products</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard2">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Out Of Stock</h4>

                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/stock/outof_stock'">
                                <h4 class="mb-0" align="right">{{Summary.outstock ? (Summary.outstock).toLocaleString() : 0}} Products</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>

              </div>
              <div class="row" v-else>
                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Stock Value</h4>
                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/stock/stockvalue'">
                                <h4 v-if="GeneralSettings.stockvalue_calculation == 0" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.BuyingstockValue ? (Summary.BuyingstockValue).toLocaleString() : 0}}</h4>
                                <h4 v-if="GeneralSettings.stockvalue_calculation == 1" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.SellingstockValue ? (Summary.SellingstockValue).toLocaleString() : 0}}</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Creditors</h4>

                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/purchases/creditors'">
                                <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.creditors ? (Summary.creditors).toLocaleString() : 0}}</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              In stock</h4>

                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/stock/in_stock'">
                                <h4 class="mb-0" align="right">{{Summary.instock ? (Summary.instock).toLocaleString() : 0}} Products</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="card mini-stats-wid smrcard">
                    <div class="card-body">
                      <!-- <div class="d-flex flex-wrap"> -->
                        <!-- <div class="me-3"> -->
                          <div class="row">
                            <div class="col-md-5">
                              <h4 class="text-muted mb-0">
                            <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                              Out Of Stock</h4>

                            </div>
                            <div class="col-md-7">
                              <router-link :to="'/stock/outof_stock'">
                                <h4 class="mb-0" align="right">{{Summary.outstock ? (Summary.outstock).toLocaleString() : 0}} Products</h4>
                              </router-link>
                            </div>
                          </div>

                          
                        <!-- </div> -->

                      <!-- </div> -->
                    </div>
                  </div>
                </div>

              </div>
              <!-- end row -->

            
            </div>
          <!-- end col -->
            
          </div>
        </div>
        
        <!-- end col -->
      </div>
      <!-- end row -->
      <div class="row" v-if="MyUserPerm.view_dashboard == 1 && MyUserPerm.view_general_summary == 1">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Annual Analysis</h4>
              <div class="row text-center">
                <div class="col-sm-3">
                  <h5 class="mb-0">{{Summary ? Summary.currency_code:''}}: {{Summary.totalPurchases ? (Summary.totalPurchases).toLocaleString(): 0}}</h5>
                  <p class="text-muted">Purchases</p>
                </div>
                <div class="col-sm-3">
                  <h5 class="mb-0">{{Summary ? Summary.currency_code:''}}: {{Summary.totalSales ?  (Summary.totalSales).toLocaleString():0}}</h5>
                  <p class="text-muted">Sales</p>
                </div>
                <div class="col-sm-3">
                  <h5 class="mb-0">{{Summary ? Summary.currency_code:''}}: {{Summary.totalExpenses ? ( Summary.totalExpenses).toLocaleString() :0}}</h5>
                  <p class="text-muted">Expenses</p>
                </div>
                <div class="col-sm-3">
                  <h5 class="mb-0">{{Summary ? Summary.currency_code:''}}: {{Summary.totalDebtors ? ( Summary.totalDebtors).toLocaleString() :0}}</h5>
                  <p class="text-muted">Total Debtors</p>
                </div>
              </div>
              <!-- Sales Chart -->
                <highcharts class="hc" :options="chartOptions" ref="chart" ></highcharts>

            </div>
          </div>
        </div>
      </div >
      </div>  
    </div>    
  </Layout> 
  <div class="row bg-warning fixed-header" v-if="CombinedDashboard">
      <div class="col-md-2">
      </div>
      <div class="col-md-8" align="center">
        <div class="row py-3 text-center">
          <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{Summary.businessname}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && Summary.branchname"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{Summary.branchname}}</h4>
        </div>
      </div>
      <div class="col-md-2" align="right">
        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/users/user1.png"
              alt="Header Avatar"
            />
            <span class="d-none d-xl-inline-block ms-1 text-white">
              {{ name?name:"Poscream User" }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block text-white"></i>
          </template>
          <!-- item-->
          
          <b-dropdown-divider></b-dropdown-divider>
          <a href="#" class="dropdown-item text-danger">
            <button class="btn btn-outline"
            @click="logoutUser()"
            >
              <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i> Logout
            </button>
            
          </a>
        </b-dropdown>
      </div>      
  </div>
  

  <div class="fixed-header-spacer">

  <div class="px-5" v-if="CombinedDashboard">
    <div class="row" v-if="branchid == 0">
    <div class="col-md-8"></div>
    <div class="col-md-4 mb-3">
      <label>FILTER BY BRANCHES</label>
      
      <model-list-select
        :list="Branches ? Branches : []"
        v-model="filterData.branch_id"
        option-value="id"
        option-text="name"
        placeholder="Select Branch"
        @input="FilterProducts()"
      >
      </model-list-select>
    </div>
  </div> 
  <div class="row mt-3">    
    <div class="col-md-3">
      <label>FILTER BY TIME</label>
      <model-list-select
        :list="this.timeFilters ? this.timeFilters : []"
        v-model="filterData.time"
        option-value="value"
        size="sm"
        @input="
          setLabel();
          FetchSummaryData();
        "
        option-text="title"
        placeholder="Select Performance"
      >
      </model-list-select>
    </div>
    <div class="col-md-3" v-show="filterData.time == 'custom'">
      <label>FROM</label>
      <input
          type="date"
          class="form-control"
          v-model="filterData.from"
        />
    </div>
    <div class="col-md-3" v-show="filterData.time == 'custom'">
      <label>To</label>
      <input
          type="date"
          class="form-control"
          v-model="filterData.to"
        />
    </div>
      <div class="col-md-3 mt-4" align="right">
      <button class="btn btn-warning" type="button" @click="FetchSummaryData()">
        <span class="fa fa-filter"></span> Filter
        <b-spinner
          v-show="filterStatus"
          variant="light"
          small
          role="status"
        ></b-spinner>
      </button>
    </div>
  </div> 
  <p class="text-center py-2 text-primary h4">Poscream Pro Statistics   <em class="text-link h6"><router-link :to="'/dashboard'">Click here for the System</router-link></em></p>
  <div class="row">
    <div class="col-md-6">
      <h4>{{ dashboardLabel || filterData.from == "" ? dashboardLabel:(filterData.from.toDateString())+' - '+(filterData.to.toDateString()) }} Summary</h4>
      <div class="col-xl-12">
        <div class="row" v-if="GeneralSettings.cash_at_hand == 1">
          <div class="col-lg-12 SummaryDiv">
            <div class="card mini-stats-wid smrcard2">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->                        
                      <div class="row">
                        <div class="col-md-5">
                          <h4 class="text-muted mb-0">
                        <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                          Sales</h4>

                        </div>                            
                        <div class="col-md-7">
                        <router-link :to="'/advanced_reports/advancedsales_report'">
                          <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{Summary.sales ? (Summary.sales).toLocaleString() : 0}}</h4>
                        </router-link>
                        </div>
                      </div>
                    
                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
            
          </div>

          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard2">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Credit Sales</h4>

                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/sales/debtors'">
                        <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.debts ? (Summary.debts ).toLocaleString() :0}}</h4>
                        </router-link>
                      </div>
                    </div>                        
                  <!-- </div> -->
                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard2">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark bg-light rounded-circle text-primary font-size-20"></i> 
                        Credits Paid</h4>

                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/advanced_reports/credit_payments'">
                          <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.credit ? (Summary.credit).toLocaleString() : 0}}</h4>
                        </router-link>
                      </div>
                    </div>                        
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12" v-if="MyUserPerm.view_expenses == 1">
            <div class="card mini-stats-wid smrcard2">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Expenses</h4>

                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/advanced_reports/expenses_report'">
                          <h4 class="mb-0" align="right">{{Summary?.currency_code || ''}}: {{formatNumber(Summary?.expenses)}}</h4>
                        </router-link>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard2">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Net Income</h4>
                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/payment/options'">
                          <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.cash ? (Summary.cash).toLocaleString() : 0}}</h4>
                        </router-link>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>

        </div>
        <div class="row" v-else>
          <div class="col-lg-12 SummaryDiv">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->                        
                      <div class="row">
                        <div class="col-md-5">
                          <h4 class="text-muted mb-0">
                        <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                          Sales</h4>

                        </div>                            
                        <div class="col-md-7">
                        <router-link :to="'/advanced_reports/sales_report'">
                          <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{Summary.sales ? (Summary.sales).toLocaleString() : 0}}</h4>
                        </router-link>
                        </div>
                      </div>
                    
                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
            
          </div>

          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Credit Sales</h4>

                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/sales/debtors'">
                          <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.debts ? (Summary.debts ).toLocaleString() :0}}</h4>
                        </router-link>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Credits Paid</h4>
                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/advanced_reports/credit_payments'">
                          <h4 class="mb-0" align="right">{{Summary?.currency_code || ''}}: {{formatNumber(Summary?.credit)}}</h4>
                        </router-link>
                      </div>
                    </div>                        
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12" v-if="MyUserPerm.view_expenses == 1">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Expenses</h4>

                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/advanced_reports/expenses_report'">
                          <h4 class="mb-0" align="right">{{Summary?.currency_code || ''}}: {{formatNumber(Summary?.expenses)}}</h4>
                        </router-link>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>

        </div>
        <!-- end row -->          
      </div>
      <!-- end col --> 
    </div>
    <div class="col-md-6">
      <h4>General Summary</h4>
      <div class="col-lg-12">
        <div class="row" v-if="GeneralSettings.show_businessvalue == 1">
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard2">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Stock Value</h4>
                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/stock/stockvalue'">
                          <h4 v-if="GeneralSettings.stockvalue_calculation == 0" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.BuyingstockValue ? (Summary.BuyingstockValue).toLocaleString() : 0}}</h4>
                          <h4 v-if="GeneralSettings.stockvalue_calculation == 1" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.SellingstockValue ? (Summary.SellingstockValue).toLocaleString() : 0}}</h4>
                        </router-link>
                      </div>
                    </div>                      
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard2">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Business Value</h4>
                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/stock/stockvalue'">
                          <h4 v-if="GeneralSettings.stockvalue_calculation == 0" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.Buying_businessvalue ? (Summary.Buying_businessvalue).toLocaleString() : 0}}</h4>
                          <h4 v-if="GeneralSettings.stockvalue_calculation == 1" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.Selling_businessvalue ? (Summary.Selling_businessvalue).toLocaleString() : 0}}</h4>
                        </router-link>
                      </div>
                    </div>                      
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>

          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard2">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Creditors</h4>

                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/purchases/creditors'">
                          <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.creditors ? (Summary.creditors).toLocaleString() : 0}}</h4>
                        </router-link>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard2">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        In stock</h4>

                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/stock/in_stock'">
                          <h4 class="mb-0" align="right">{{Summary.instock ? (Summary.instock).toLocaleString() : 0}} Products</h4>
                        </router-link>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard2">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Out Of Stock</h4>

                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/stock/outof_stock'">
                          <h4 class="mb-0" align="right">{{Summary.outstock ? (Summary.outstock).toLocaleString() : 0}} Products</h4>
                        </router-link>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>

        </div>
        <div class="row" v-else>
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Stock Value</h4>
                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/stock/stockvalue'">
                          <h4 v-if="GeneralSettings.stockvalue_calculation == 0" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.BuyingstockValue ? (Summary.BuyingstockValue).toLocaleString() : 0}}</h4>
                          <h4 v-if="GeneralSettings.stockvalue_calculation == 1" class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.SellingstockValue ? (Summary.SellingstockValue).toLocaleString() : 0}}</h4>
                        </router-link>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>

          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Creditors</h4>

                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/purchases/creditors'">
                          <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.creditors ? (Summary.creditors).toLocaleString() : 0}}</h4>
                        </router-link>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        In stock</h4>

                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/stock/in_stock'">
                          <h4 class="mb-0" align="right">{{Summary.instock ? (Summary.instock).toLocaleString() : 0}} Products</h4>
                        </router-link>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Out Of Stock</h4>

                      </div>
                      <div class="col-md-7">
                        <router-link :to="'/stock/outof_stock'">
                          <h4 class="mb-0" align="right">{{Summary.outstock ? (Summary.outstock).toLocaleString() : 0}} Products</h4>
                        </router-link>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>

        </div>
        <!-- end row -->

      
      </div>
    <!-- end col -->
      
    </div>
  </div>
  <!-- end row -->

  <p class="text-center py-2 text-primary h4">Poscream Fuels Statistics   
    <em class="text-info h6" @click="fuelslogin()">
      <a style="cursor: pointer;" download>
        Click here for the System
      </a>      
    </em>
  </p>

  <div class="row">
    <div class="col-md-6">
      <div class="col-xl-12">
        <div class="row">
          <div class="col-lg-12 SummaryDiv">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->                        
                      <div class="row">
                        <div class="col-md-5">
                          <h4 class="text-muted mb-0">
                        <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                          Sales</h4>

                        </div>                            
                        <div class="col-md-7">
                          <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{Summary.poscreamfuels ? (Summary.poscreamfuels.sales) : 0}}</h4>
                        </div>
                      </div>                    
                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
            
          </div>

          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Expenses</h4>

                      </div>
                      <div class="col-md-7">
                        <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.poscreamfuels ? (Summary.poscreamfuels.expenses ) :0}}</h4>
                      </div>
                    </div>
                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Discounts</h4>
                      </div>
                      <div class="col-md-7">
                        <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.poscreamfuels ? (Summary.poscreamfuels.discounts) : 0}}</h4>
                      </div>
                    </div>                        
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>

          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Cash Balance</h4>

                      </div>
                      <div class="col-md-7">
                        <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.poscreamfuels ? (Summary.poscreamfuels.cash) : 0}}</h4>
                      </div>
                    </div>
                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>

        </div>
        <!-- end row -->          
      </div>
      <!-- end col --> 
    </div>
    <div class="col-md-6">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Stock Value</h4>
                      </div>
                      <div class="col-md-7">
                        <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}} : {{ Summary.poscreamfuels ? (Summary.poscreamfuels.stockvalue) : 0}}</h4>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Creditors</h4>

                      </div>
                      <div class="col-md-7">
                        <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.poscreamfuels ? (Summary.poscreamfuels.totalcreditors) : 0}}</h4>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Debtors</h4>

                      </div>
                      <div class="col-md-7">
                        <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.poscreamfuels ? (Summary.poscreamfuels.totaldebtors) : 0}}</h4>
                      </div>
                    </div>

                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>

          <div class="col-lg-12">
            <div class="card mini-stats-wid smrcard">
              <div class="card-body">
                <!-- <div class="d-flex flex-wrap"> -->
                  <!-- <div class="me-3"> -->
                    <div class="row">
                      <div class="col-md-5">
                        <h4 class="text-muted mb-0">
                      <i class="bx bxs-book-bookmark  bg-light rounded-circle text-primary font-size-20"></i> 
                        Bank Balance</h4>

                      </div>
                      <div class="col-md-7">
                        <h4 class="mb-0" align="right">{{Summary ? Summary.currency_code:''}}: {{Summary.poscreamfuels ? (Summary.poscreamfuels.bank) : 0}}</h4>
                      </div>
                    </div>                    
                  <!-- </div> -->

                <!-- </div> -->
              </div>
            </div>
          </div>

        </div>
        <!-- end row -->

      
      </div>
    <!-- end col -->
      
    </div>
  </div>
  <!-- end row -->
  <div class="row">      
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <h4 class="card-title mb-4 text-center">Poscream Pro Annual Analysis</h4>
            <div class="row text-center">
              <div class="col-sm-3">
                <h5 class="mb-0">{{Summary ? Summary.currency_code:''}}: {{Summary.totalPurchases ? (Summary.totalPurchases).toLocaleString(): 0}}</h5>
                <p class="text-muted">Purchases</p>
              </div>
              <div class="col-sm-3">
                <h5 class="mb-0">{{Summary ? Summary.currency_code:''}}: {{Summary.totalSales ?  (Summary.totalSales).toLocaleString():0}}</h5>
                <p class="text-muted">Sales</p>
              </div>
              <div class="col-sm-3">
                <h5 class="mb-0">{{Summary ? Summary.currency_code:''}}: {{Summary.totalExpenses ? ( Summary.totalExpenses).toLocaleString() :0}}</h5>
                <p class="text-muted">Expenses</p>
              </div>
              <div class="col-sm-3">
                <h5 class="mb-0">{{Summary ? Summary.currency_code:''}}: {{Summary.totalDebtors ? ( Summary.totalDebtors).toLocaleString() :0}}</h5>
                <p class="text-muted">Total Debtors</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <h4 class="card-title mb-4 text-center">Poscream Fuels Annual Analysis</h4>
            <div class="row text-center">
              <div class="col-sm-3">
                <h5 class="mb-0">{{Summary ? Summary.currency_code:''}}: {{Summary.poscreamfuels ? (Summary.poscreamfuels.annualpurchases): 0}}</h5>
                <p class="text-muted">Purchases</p>
              </div>
              <div class="col-sm-3">
                <h5 class="mb-0">{{Summary ? Summary.currency_code:''}}: {{Summary.poscreamfuels ?  (Summary.poscreamfuels.annualsales):0}}</h5>
                <p class="text-muted">Sales</p>
              </div>
              <div class="col-sm-3">
                <h5 class="mb-0">{{Summary ? Summary.currency_code:''}}: {{Summary.poscreamfuels ? ( Summary.poscreamfuels.annualexpenses) :0}}</h5>
                <p class="text-muted">Expenses</p>
              </div>
              <div class="col-sm-3">
                <h5 class="mb-0">{{Summary ? Summary.currency_code:''}}: {{Summary.poscreamfuels ? ( Summary.poscreamfuels.annualdebtors) :0}}</h5>
                <p class="text-muted">Total Debtors</p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Sales Chart -->
        <highcharts class="hc" :options="chartOptions" ref="chart" ></highcharts>
      </div>
    </div>
  </div >  
  </div>
</div> 
</div>
</template>
<style type="text/css">
.smrcard{
  box-shadow: 2px 2px 4px #000000;  margin-top: 00px !important;
  height:83px !important;
  margin-bottom:10px !important;

}
.smrcard2{
  box-shadow: 2px 2px 4px #000000;  margin-top: 00px !important;
  height:65px !important;
  margin-bottom:10px !important;

}
.SummaryDiv{
  margin-bottom:0px !important;

}
.hc{
  height:500px !important;
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 80px;
  z-index: 1000;
}

.fixed-header-spacer {
  margin-top: 90px;
}
</style>
